import { useQuery } from "@apollo/client";
import { CircularProgress } from "@material-ui/core";
import React, { FC } from "react";
import { Navigate } from "react-router";
import { OnboardingInfo } from "../../../graphql/onboarding/onboarding/types/OnboardingInfo";
import { ONBOARDING } from "../../../graphql/onboarding/onboarding/query";
import { OnboardingStep } from "../../../enums/onboarding";

const SignupProgression: FC = () => {
  const { data, loading, error } = useQuery<OnboardingInfo>(ONBOARDING, {
    fetchPolicy: "no-cache",
  });
  if (loading) return <CircularProgress />;
  if (!data || error) return null;
  if (data?.onboardingInfo?.company?.step) {
    const { company } = data.onboardingInfo;
    const { step, code, isIndividual } = company;
    switch (step) {
      case OnboardingStep.INFORMATION:
        return <Navigate to={code ? `/companyInfo/${code}` : "/company"} />;
      case OnboardingStep.LEADER:
        return <Navigate to="/manager" />;
      case OnboardingStep.UBO:
        return <Navigate to="/shareholdersPercent" />;
      case OnboardingStep.GET_ID:
        return <Navigate to="/identity-verification" />;
      case OnboardingStep.CONTRACT:
        return <Navigate to="/contrat" />;
      case OnboardingStep.FINISH:
        return <Navigate to="/contrat" />;
      case OnboardingStep.OFFER:
        return <Navigate to="/offer" />;
      case OnboardingStep.STRIPE:
        return (
          <Navigate to={isIndividual ? "/manager" : "/shareholdersPercent"} />
        );
      case OnboardingStep.PACKAGE:
        return <Navigate to="/explanation" />;
      case OnboardingStep.LEGAL_PLACE:
        return <Navigate to="/legalplace" />;
      default:
        return <Navigate to="/choise" />;
    }
  } else {
    return <Navigate to="/choise" />;
  }
};
export default SignupProgression;
